import React, { useState } from 'react';
import { DashboardPage } from './pages/DashboardPage';
import { ClientsPage } from './pages/ClientsPage';
import { ClientDetailPage } from './pages/ClientDetailPage';
import { NetworkPage } from './pages/NetworkPage';
import { DeveloperOfficePage } from './pages/DeveloperOfficePage';
import { RequestTicketPage } from './pages/RequestTicketPage';
import { DeveloperInfoPage } from './pages/DeveloperInfoPage';
import { DeveloperDetailsPage } from './pages/DeveloperDetailsPage';
import { InventoryPage } from './pages/InventoryPage';
import { RMIPage } from './pages/RMIPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { CalendarPage } from './pages/CalendarPage';
import { ChatPage } from './pages/ChatPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { NotificationsPage } from './pages/NotificationsPage';
type CurrentPage = 'dashboard' | 'clients' | 'detail' | 'network' | 'developer-office' | 'request-ticket' | 'developer-info' | 'developer-details' | 'inventory' | 'rmi' | 'properties' | 'calendar' | 'chat' | 'project-detail' | 'notifications';
export function App() {
  const [currentPage, setCurrentPage] = useState<CurrentPage>('dashboard');
  const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
  const [selectedDeveloper, setSelectedDeveloper] = useState<{
    id: number;
    name: string;
    tier?: 'gold' | 'silver' | 'bronze';
  } | null>(null);
  const [selectedRequestId, setSelectedRequestId] = useState<number | null>(null);
  const [selectedProjectId, setSelectedProjectId] = useState<number | null>(null);
  const [projectDetailSource, setProjectDetailSource] = useState<'developer-office' | 'inventory'>('developer-office');
  const handleClientClick = (id: number) => {
    setSelectedClientId(id);
    setCurrentPage('detail');
    window.scrollTo(0, 0);
  };
  const handleBack = () => {
    setCurrentPage('clients');
    setSelectedClientId(null);
  };
  const handleNetworkClick = () => {
    setCurrentPage('network');
    window.scrollTo(0, 0);
  };
  const handleNetworkBack = () => {
    setCurrentPage('clients');
  };
  const handleInventoryClick = () => {
    setCurrentPage('inventory');
    window.scrollTo(0, 0);
  };
  const handleInventoryBack = () => {
    setCurrentPage('clients');
  };
  const handleInventoryProjectClick = (projectId: number, developerId: number, developerName: string) => {
    setSelectedProjectId(projectId);
    setSelectedDeveloper({
      id: developerId,
      name: developerName
    });
    setProjectDetailSource('inventory');
    setCurrentPage('project-detail');
    window.scrollTo(0, 0);
  };
  const handleRMIClick = () => {
    setCurrentPage('rmi');
    window.scrollTo(0, 0);
  };
  const handleRMIBack = () => {
    setCurrentPage('clients');
  };
  const handlePropertiesClick = () => {
    setCurrentPage('properties');
    window.scrollTo(0, 0);
  };
  const handleClientsClick = () => {
    setCurrentPage('clients');
    window.scrollTo(0, 0);
  };
  const handleDashboardClick = () => {
    setCurrentPage('dashboard');
    window.scrollTo(0, 0);
  };
  const handleDeveloperOfficeClick = (developerId: number, developerName: string, tier?: 'gold' | 'silver' | 'bronze') => {
    setSelectedDeveloper({
      id: developerId,
      name: developerName,
      tier
    });
    setCurrentPage('developer-office');
    window.scrollTo(0, 0);
  };
  const handleDeveloperOfficeBack = () => {
    setCurrentPage('network');
    setSelectedDeveloper(null);
  };
  const handleRequestClick = (requestId: number) => {
    setSelectedRequestId(requestId);
    setCurrentPage('request-ticket');
    window.scrollTo(0, 0);
  };
  const handleRequestTicketBack = () => {
    // Check if we came from RMI page or developer office
    if (selectedDeveloper) {
      setCurrentPage('developer-office');
    } else {
      setCurrentPage('rmi');
    }
    setSelectedRequestId(null);
  };
  const handleDeveloperInfoClick = (developerId: number, developerName: string) => {
    setSelectedDeveloper({
      id: developerId,
      name: developerName
    });
    setCurrentPage('developer-info');
    window.scrollTo(0, 0);
  };
  const handleDeveloperInfoClose = () => {
    setCurrentPage('network');
    setSelectedDeveloper(null);
  };
  const handleGetAccreditedClick = () => {
    if (selectedDeveloper) {
      setCurrentPage('developer-details');
      window.scrollTo(0, 0);
    }
  };
  const handleDeveloperDetailsBack = () => {
    setCurrentPage('developer-info');
  };
  const handleAccreditationSubmit = () => {
    // Handle accreditation submission
    alert('Accreditation request submitted successfully!');
    setCurrentPage('network');
    setSelectedDeveloper(null);
  };
  const handleCalendarClick = () => {
    setCurrentPage('calendar');
    window.scrollTo(0, 0);
  };
  const handleCalendarBack = () => {
    setCurrentPage('clients');
  };
  const handleChatClick = () => {
    setCurrentPage('chat');
    window.scrollTo(0, 0);
  };
  const handleChatBack = () => {
    setCurrentPage('clients');
  };
  const handleProjectClick = (projectId: number) => {
    setSelectedProjectId(projectId);
    setProjectDetailSource('developer-office');
    setCurrentPage('project-detail');
    window.scrollTo(0, 0);
  };
  const handleProjectDetailBack = () => {
    if (projectDetailSource === 'inventory') {
      setCurrentPage('inventory');
      setSelectedDeveloper(null);
    } else {
      setCurrentPage('developer-office');
    }
    setSelectedProjectId(null);
  };
  const handleProjectDetailBackFromInventory = () => {
    setCurrentPage('inventory');
    setSelectedProjectId(null);
    setSelectedDeveloper(null);
  };
  const handleNotificationsClick = () => {
    setCurrentPage('notifications');
    window.scrollTo(0, 0);
  };
  const handleNotificationsBack = () => {
    setCurrentPage('dashboard');
  };
  return <div className="bg-neutral-bg min-h-screen w-full overflow-x-hidden" data-id="element-0">
      {currentPage === 'dashboard' && <DashboardPage onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onPropertiesClick={handlePropertiesClick} onClientsClick={handleClientsClick} onCalendarClick={handleCalendarClick} onChatClick={handleChatClick} onNotificationsClick={handleNotificationsClick} data-id="element-1" />}
      {currentPage === 'notifications' && <NotificationsPage onBack={handleNotificationsBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onCalendarClick={handleCalendarClick} onChatClick={handleChatClick} data-id="element-2" />}
      {currentPage === 'clients' && <ClientsPage onClientClick={handleClientClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onPropertiesClick={handlePropertiesClick} onCalendarClick={handleCalendarClick} onChatClick={handleChatClick} onDashboardClick={handleDashboardClick} onNotificationsClick={handleNotificationsClick} data-id="element-3" />}
      {currentPage === 'properties' && <PropertiesPage onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} onClientsClick={handleClientsClick} onDashboardClick={handleDashboardClick} data-id="element-4" />}
      {currentPage === 'detail' && <ClientDetailPage clientId={selectedClientId || 1} onBack={handleBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} data-id="element-5" />}
      {currentPage === 'network' && <NetworkPage onBack={handleNetworkBack} onDeveloperOfficeClick={handleDeveloperOfficeClick} onDeveloperInfoClick={handleDeveloperInfoClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} data-id="element-6" />}
      {currentPage === 'inventory' && <InventoryPage onBack={handleInventoryBack} onNetworkClick={handleNetworkClick} onRMIClick={handleRMIClick} onInventoryClick={handleInventoryClick} onProjectClick={handleInventoryProjectClick} data-id="element-7" />}
      {currentPage === 'rmi' && <RMIPage onBack={handleRMIBack} onRequestClick={handleRequestClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} data-id="element-8" />}
      {currentPage === 'developer-office' && selectedDeveloper && <DeveloperOfficePage developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} tier={selectedDeveloper.tier} onBack={handleDeveloperOfficeBack} onRequestClick={handleRequestClick} onProjectClick={handleProjectClick} data-id="element-9" />}
      {currentPage === 'request-ticket' && selectedRequestId && <RequestTicketPage requestId={selectedRequestId} onBack={handleRequestTicketBack} data-id="element-10" />}
      {currentPage === 'developer-info' && selectedDeveloper && <DeveloperInfoPage developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} onClose={handleDeveloperInfoClose} onGetAccredited={handleGetAccreditedClick} data-id="element-11" />}
      {currentPage === 'developer-details' && selectedDeveloper && <DeveloperDetailsPage developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} onBack={handleDeveloperDetailsBack} onAccreditationSubmit={handleAccreditationSubmit} showAccreditationModal={true} data-id="element-12" />}
      {currentPage === 'calendar' && <CalendarPage onBack={handleCalendarBack} onClientClick={handleClientClick} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} data-id="element-13" />}
      {currentPage === 'chat' && <ChatPage onBack={handleChatBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} data-id="element-14" />}
      {currentPage === 'project-detail' && selectedDeveloper && selectedProjectId && <ProjectDetailPage projectId={selectedProjectId} developerId={selectedDeveloper.id} developerName={selectedDeveloper.name} developerTier={selectedDeveloper.tier} onBack={handleProjectDetailBack} onNetworkClick={handleNetworkClick} onInventoryClick={handleInventoryClick} onRMIClick={handleRMIClick} data-id="element-15" />}
    </div>;
}